import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {

  constructor(private GAService:GoogleAnalyticsService) { }

  ngOnInit(): void {

  }

 
 

}
